import { Component, Vue } from 'vue-property-decorator';

@Component
export default class UseModal extends Vue {
  isModalOpen = false;

  isModalSubmitting = false;

  showModal() {
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }
}
